import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {ImageColorSpace} from "@generated"
import {MeasurementType, MeasurementTypes} from "@common/models/settings/settings"
import {Labels} from "@labels"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-upload-texture-settings-dialog",
    templateUrl: "./upload-texture-settings-dialog.component.html",
    styleUrls: ["./upload-texture-settings-dialog.component.scss"],
    imports: [MatDialogModule, MatInputModule, FormsModule, MatSelectModule, MatButtonModule],
})
export class UploadTextureSettingDialogComponent {
    readonly $result = signal<Partial<UploadTextureSettingDialogResult>>({
        displacement: undefined,
        colorSpace: undefined,
    })
    readonly dialogRef = inject(MatDialogRef<UploadTextureSettingDialogComponent>)
    readonly data = inject<{showDisplacementSetting?: boolean; displacement?: number; measurementType?: MeasurementType; colorSpace?: ImageColorSpace}>(
        MAT_DIALOG_DATA,
    )

    constructor() {
        if (this.data) {
            this.$result.set({
                displacement: this.data.displacement,
                colorSpace: this.data.colorSpace,
            })
            this.$imperial.set(this.data.measurementType === MeasurementTypes.Imperial)
            this.$showDisplacementSetting.set(this.data.showDisplacementSetting ?? false)
        }
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(): void {
        if (this.$result() && this.$imperial()) {
            if (this.$result().displacement) {
                this.$result.update((current) => ({...current, displacement: MeasurementTypes.Imperial.convertToMetric(current.displacement!)}))
            }
        }
        this.dialogRef.close(this.$result())
    }

    protected readonly ImageColorSpace = ImageColorSpace
    protected readonly Labels = Labels

    readonly $imperial = signal(false)
    readonly $showDisplacementSetting = signal(true)
}

export type UploadTextureSettingDialogResult = {
    colorSpace: ImageColorSpace
    displacement?: number
}
